import { Query } from '@datorama/akita';

import { GuestReportState, guestReportStore } from './guest-report.store';

export class GuestReportQuery extends Query<GuestReportState> {
  report = this.select(({ report }) => report);

  maintenanceTicketNumber = this.select(({ maintenanceTicketNumber }) => maintenanceTicketNumber);
}

export const guestReportQuery = new GuestReportQuery(guestReportStore);
